import { TRACK_IDS } from "../../../analytics/trackIds";
import React from "react";
import { programs } from "../../../api/mockup/mockup";
import ForwardSecondsIcon from "../../../assets/icons/svg/ForwardSecondsIcon";
import localizationStrings from "../../../statics/localization";
import { seekBy } from "./playerInteraction";

const RewindForwardButton = ({ player, isFullscreen }) => {
  let secsToBack = 10;

  return (
    <button
      data-track-id={TRACK_IDS.PLAYER_REWIND_FORWARD}
      className="control-button"
      title={localizationStrings.playerOptions.sectsToForward}
      onClick={() => {
        seekBy(player, secsToBack);
      }}
    >
      <ForwardSecondsIcon />
    </button>
  );
};

export default RewindForwardButton;
